import React from 'react';
import './index.css';
import HeaderVwLogo from './media/logo_vwm.svg';
import HeaderSeatLogo from './media/logo_seat.svg';
import HeaderAudiLogo from './media/logo_audi.svg';
import HeaderCupraLogo from './media/logo_cupra.svg';

import HeaderWeb from './media/header_movil.png';
import logoFBSeat from './media/Fb.svg';
import logoFBAudi from './media/Fb_audi.svg';
import "react-datepicker/dist/react-datepicker.css";

class Header extends React.Component {
    
    render(){
        return(
            <React.Fragment>
                <div className={"text-center mt-4 title_container text__center--" + this.props.marca}>
                    {
                        this.props.marca==="seat"?<div className="container text-left"><img src={HeaderSeatLogo} alt="SEAT Logo" width="125px"></img></div>:(this.props.marca==="audi"?<div className="container text-right"><img src={HeaderAudiLogo} width="85px" alt="Audi Logo"></img></div>:(this.props.marca==="cupra"?<div className="container text-left"><img src={HeaderCupraLogo} width="125px" alt="Cupra Logo"></img></div>:<img src={HeaderVwLogo} alt="VW Logo"></img>))
                    }
                </div>
                <div className={"title__container container-fluid h-100 title__container--"+this.props.marca}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-5 mt-3 h-100">
                                <h1><span className="font-weight-bold">Sigue</span><span className="font-weight-light">Tu</span></h1>
                                <h2><span className="font-weight-light">Salesforce {
                                    this.props.marca==="seat"?(
                                        <React.Fragment> - <img src={logoFBSeat} alt="Logo Facebook"/></React.Fragment>
                                    ):(
                                        this.props.marca==="audi"?(
                                            <img src={logoFBAudi} alt="Logo Facebook"/>
                                        ):(this.props.marca==="cupra"?(
                                            <React.Fragment> - <img src={logoFBSeat} alt="Logo Facebook"/></React.Fragment>):"- DTO")
                                    )
                                }
                                </span></h2>
                            </div>
                            <div className="col-md-7 d-none d-md-block">
                                <img src={HeaderWeb} alt="Header" />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };
}

export default Header;